import { useMemo } from 'react';
import { useGetCmsConfigsQuery } from '../../apis/cmsApi/cms.hooks.api';
import { Order, OrderState } from '../../models';
import { useOrder } from '../useOrder';

export const useIsEditReviewEnabled = () => {
  const order = useOrder();
  const { data: cmsConfigs } = useGetCmsConfigsQuery(undefined);

  const isEditReviewEnabled = useMemo(() => {
    if (order && cmsConfigs)
      return getIsEditReviewAvailable(
        order,
        cmsConfigs.featureFlags.isReviewEnabled
      );
    return false;
  }, [cmsConfigs, order]);

  return isEditReviewEnabled;
};

const getIsEditReviewAvailable = (
  { status, ...order }: Order,
  isServiceEnabled: boolean
) => {
  const isValidOrderState = status === OrderState.Fulfilled;
  const hasReview = order.review?.rating;
  return isValidOrderState && hasReview && isServiceEnabled;
};
